import { message, Result } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { errorMessage } from "../../../utils/errors";
import meta from "../../../utils/meta";
import { sendEmployeeLoginLink, sendFacilityLoginLink } from "./api";
import { LoginForm } from "./loginForm";
import { LoginLayout } from "./loginLayout";
import { getSignInLink } from "frontend-admin/src/utils/user";
import { useRedirectToContractPage } from "frontend-admin/src/hooks/useRedirectToContractPage";

const AdminAppLogin = ({ requestedURL }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [keepMeLogin, setKeepMeLogin] = useState(true);
  const [emailSent, setEmailSent] = useState(false);
  const { search } = useLocation();
  const { evaluateAndSetRedirectUrlIntoLocalStorage } =
    useRedirectToContractPage();

  useEffect(() => {
    // To display error message when login link invalid/expired or failed because of some other reason
    const failed = new URLSearchParams(search).get("failed");
    const email = new URLSearchParams(search).get("email");
    setEmail(email || "");
    if (failed === "true") {
      message.error(
        "Link verification failed. Please try again or contact Support if the issue persists.",
      );
    }
  }, []);

  const onSubmit = async () => {
    if (!email) {
      message.error("Please enter valid email.");
      return;
    }

    setLoading(true);
    try {
      const signInLink = getSignInLink(requestedURL, email, keepMeLogin);
      const res = email.includes("clipboardhealth.com")
        ? await sendEmployeeLoginLink(email, signInLink)
        : await sendFacilityLoginLink(email, signInLink);

      localStorage.clear();
      evaluateAndSetRedirectUrlIntoLocalStorage();
      if (res.success) setEmailSent(true);
      setLoading(false);
    } catch (err) {
      message.error(errorMessage(err));
      setLoading(false);
    }
  };

  return (
    <LoginLayout>
      {!emailSent && (
        <LoginForm
          email={email}
          setKeepMeLogin={setKeepMeLogin}
          setEmail={setEmail}
          loading={loading}
          onSubmit={onSubmit}
          keepMeLogin={keepMeLogin}
        />
      )}
      {emailSent && (
        <Result
          status="success"
          title="Verification Link Sent"
          subTitle={`We have sent an email with a login link to ${email}.`}
        />
      )}
    </LoginLayout>
  );
};

export { AdminAppLogin };
